import * as ProjectHelper from '../../api/project/projectHelper';
import validationAlertOutput from '../../validation';
import { EStatusCode } from '../enum';
import CalculationProvider from './calculationProvider';
import { IGetCalculateAsync } from './iApiRequest';

export const getCalculateAsync = async (payload: IGetCalculateAsync) => {
    let resUpdateProject = await ProjectHelper.saveProjectAsync(payload.project);
    if (resUpdateProject?.status == EStatusCode.Ok) {
        payload.project = resUpdateProject.data!;
        let res = await CalculationProvider.getCalculateAsync(payload);
        validationAlertOutput(res.data);
        return res;
    }
};
